
export const emailRoxana = 'thornhillspanish@yahoo.com';



// WEBPACK FOOTER //
// ./src/constants/constants.js